import React, { useEffect, useRef, useState } from "react";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import InventoryDetails from "../components/InventoryDetails";
import Status from "../ui/Status";
import { InfoIcon } from "../utils/Icons";
import ReconciliationList from "../components/ReconciliationList";
import Nav from "../ui/Nav";
import { ROUTES } from "../utils/Routes";
import { pubCall, pubSub } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import { bm_date, istl, showConfirm, showInfo } from "../utils/Utils";
import ReconciliationSearch from "../popups/ReconciliationSearch";
import { createModal } from "../hooks/createModal";
import ReconciliationExtras from "../popups/ReconciliationExtras";
import ImportCounts from "../components/reconciliation/ImportCounts";
import Logout from "../components/authentication/Logout";
import InventoryHistory from "../components/InventoryHistory";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Divider from "../ui/Divider";

export default function ReconciliationController(props) {

    const { controller = "", signal = {}, callback = () => { }, route = "", WS_ONLY = false } = props;

    const [data, setData] = useState([]);
    const [selected, setSelected] = useState({});
    const [fullData, setFullData] = useState({});
    const [align, setAlign] = useState("auto");
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({ oh_filter: false, work_station_filter: true, limit: 45 })
    const [edit, setEdit] = useState(false);
    const [isNew, setIsNew] = useState(false);

    const _new = { reconciliation_id: "new", is_new: true, counted: 2 };

    const [state, setState] = useState({
        view: "reconciliation",
        edit: false,
        new: false,
        copy: false,
        history_checked: false,
        tabs: "history",
        pubstock: "min"
    })

    const in_stock = (selected?.stock_id && istl(selected)) ? false : true;
    const history_filters = {
        adjustment: true,
        held: true,
        orders: true,
        orders: true,
        prepay: true,
        quotes: false,
        returns: true,
        sales: true,
        transfers: true
    }
    const [historyFilters, setHistoryFilters] = useState(history_filters);

    const [index, setIndex] = useState("new_count");

    const [tabs, setTabs] = useState([
        { key: "new_code", value: "" },
        { key: "new_count", value: 1 },
    ])




    const showWarning = (_date) => {
        showConfirm({
            controller: controller,
            route: window.bm_state.value,
            description: <div style={{ "textAlign": "center" }}>Your reconciliation file contains old data from before {bm_date(_date)}.<br /><br /> Do you want to purge reconciliation before you start scanning?</div>,
            title: "Warning",
            callback: (e) => {
                if (e) {
                    pubCall("reconciliation.purgeList", {}, (_s, _r) => {
                        if (_s) {
                            showMessage("Reconciliation file purged");
                            fetch();
                        } else {
                            showError(_r);
                        }
                    })
                }
            }
        })
    }

    // useEffect(() => {
    //     pubCall("reconciliation.isLatestScanOld", {}, (_s, _r) => {
    //         if (_s) {
    //             if (_r?.date) {
    //                 showWarning(_r.date);
    //             }
    //         } else {
    //             showError(_r)
    //         }
    //     })
    // }, [])



    const switchView = () => {

        if (state?.view === "history") {
            setState({ ...state, "view": "reconciliation" });
            window.bm_state.value = ROUTES.RECONCILIATION.RECONCILIATION;
        } else {
            setState({ ...state, "view": "history" });
            window.bm_state.value = ROUTES.INVENTORY.HISTORY;
        }
    }
    // Subscription
    const [record, setRecord] = useState(null);

    // Listen for record updates..
    useEffect(() => {
        // Only update when in list mode...

        // Only update when there is an action
        if (!record?.action) { return; }


        const action = record?.action;

        switch (action) {

            case "reload":
                showInfo({
                    controller: controller,
                    route: route,
                    description: <div style={{ "textAlign": "center", "maxWidth": "340px", "lineHeight": "18px" }}>Bulk changes detected<div className="shim" />Reloading...</div>,
                    callback: () => {
                        fetch(false);
                        setRecord({});
                        setIsNew(false);
                        showMessage("Bulk changes applied.")
                    }
                });
                break;

            case "row_new":
                if (window.bm_state.value !== ROUTES.RECONCILIATION.RECONCILIATION) { return; }
                if (filters.oh_filter || filters.work_station_filter) { return; }

                setData([...data].concat([record?.data]));
                setRecord({});
                break;

            case "row_update":
                if (window.bm_state.value !== ROUTES.RECONCILIATION.RECONCILIATION) { return; }
                let _f = data.findIndex(item => (item.primary_code === record?.data?.primary_code && item.condition_code === record?.data?.condition_code));
                if (_f > -1) {
                    // Found. Update...
                    let _r = [...data];
                    _r[_f] = { ...record.data };
                    setData(_r);
                    setRecord({});

                } else {
                    // Not Found. Add...
                    if (filters.oh_filter || filters.work_station_filter) { return; }

                    setData([...data].concat([record?.data]));
                    setRecord({});
                }
                break;

            case "row_delete":
                if (window.bm_state.value !== ROUTES.RECONCILIATION.RECONCILIATION) { return; }
                let _drop = data.filter(item => item.reconciliation_id !== record?.data.reconciliation_id);
                setData(_drop);
                setRecord({});
                break;
        }

    }, [record, filters])

    // Subscription to state
    useEffect(() => {
        if (record) { return; }
        pubSub("reconciliation", {}, (_e, _f = {}) => {
            setRecord(_f.message)
        })
    }, [record])




    const updateRow = (_data) => {
        let _d = [...data];
        let _f = _d.findIndex(item => item.reconciliation_id === _data.reconciliation_id);
        if (_f > -1) {
            _d[_f] = _data;
            console.log(_data)
            setSelected(_d[_f]);
            setData(_d);
        }
    }

    const fetchExtra = () => {

        // don't fetch if no rec id
        if (!selected?.stock_data?.stock_id) {
            setFullData({})
            return;
        }

        const timeoutId = setTimeout(() => {
            pubCall("stock.getSingleExtras", {
                stock_id: selected.stock_data.stock_id,
                adjustment: historyFilters.adjustment,
                held: historyFilters.held,
                orders: historyFilters.orders,
                prepay: historyFilters.prepay,
                quotes: historyFilters.quotes,
                returns: historyFilters.returns,
                transfers: historyFilters.transfers,
                sales: historyFilters.sales

            }, (_s, _r) => {
                if (_s) {
                    setFullData(_r);
                } else {
                    showError(_r);
                }
            })
        }, 100);
        return () => {
            clearTimeout(timeoutId);
        };
    }


    useEffect(fetchExtra, [selected])


    const fetch = (is_new = isNew) => {

        if (loading) { return }
        setLoading(true);
        let _filters = { ...filters };

        if (selected?.reconciliation_id) {
            _filters.reconciliation_id = selected.reconciliation_id;
        }
        pubCall("reconciliation.getLast", _filters, (_s, _r) => {
            if (_s) {
                if (_r.length > 0) {
                    // setAlign("end");
                }

                if (is_new) {
                    setData(_r.concat([_new]));
                    setSelected(_new);
                } else {
                    setData(_r);
                    setSelected((_r.length > 0) ? _r[_r.length - 1] : {})
                }

            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }

    useEffect(fetch, [filters]);

    // COUNT
    const toggleEdit = () => {
        if (edit) {
            window.bm_state.value = ROUTES.RECONCILIATION.RECONCILIATION;
            setEdit(false);
        } else {
            window.bm_state.value = ROUTES.RECONCILIATION.COUNT;
            setEdit(selected.reconciliation_id)
        }
    }


    const getNew = () => {
        window.bm_state.value = ROUTES.RECONCILIATION.NEW;
        setIsNew(true);

        if (filters.work_station_filter !== true || filters.oh_filter) {
            setFilters({ ...filters, "work_station_filter": true, "oh_filter": false })
        } else {
            setData([...data].concat([_new]));
            setSelected(_new);
        }
    }





    const deleteRow = () => {
        let _id = selected?.reconciliation_id;
        if (!_id) { showError({ error: "No record selected." }); return; }
        showConfirm({
            controller: controller,
            route: ROUTES.RECONCILIATION.RECONCILIATION, title: "Remove?", description: <>Remove entry from reconciliation list?</>, callback: (_ret) => {
                if (_ret) {
                    pubCall("reconciliation.delete", { reconciliation_id: _id }, (_s, _r) => {
                        if (_s) {
                            let _data = [...data].filter(item => item.reconciliation_id !== _id);
                            setData(_data);
                            setSelected((_data.length > 0) ? _data[_data.length - 1] : {});
                        } else {
                            showError(_r);
                        }
                    })
                }
            }
        })
    }


    const updateCount = () => {
        let _args = {
            primary_code: selected.primary_code,
            condition_code: selected.condition_code,
            count: parseInt(selected.counted) || 0,
        }
        pubCall("reconciliation.submit", _args, (_status, _result) => {
            if (_status) {
                updateRow(_result);
                showMessage("Count updated successfully.");
            } else {
                showError(_result);
            }
            toggleEdit();
        })
    }

    useEffect(() => {
        const actions = [
            { key: KBD.ESCAPE, action: (e) => { toggleEdit() } },
            { key: KBD.ENTER, action: (e) => { updateCount(false) } },
            { key: KBD.PAGE_DOWN, action: (e) => { updateCount(false) } },



        ];
        const cleanup = listen(controller, ROUTES.RECONCILIATION.COUNT, actions, false, [KBD.ESCAPE, KBD.ENTER, KBD.PAGE_DOWN]);
        return cleanup;
    }, [selected, edit, state]);




    const showSearch = () => {
        window.bm_state.value = ROUTES.RECONCILIATION.SEARCH;
        createModal({
            offset: [0, -80],
            component: <ReconciliationSearch controller={controller} filters={filters} route={ROUTES.RECONCILIATION.SEARCH} />, title: "Search", closable: true, callback: (_r) => {
                if (_r) {
                    if (_r.rows_previous.length > 0) {
                        setAlign("start");
                    }
                    setData(_r.rows_previous.concat(_r.rows_next));
                    setSelected((_r.rows_next.length > 0) ? _r.rows_next[0] : {})
                }
                window.bm_state.value = ROUTES.RECONCILIATION.RECONCILIATION;
            }
        })
    }

    const showLogout = () => {
        window.bm_state.value = ROUTES.AUTHENTICATION.LOGOUT;
        createModal({
            offset: [0, -80],
            component: <Logout controller={controller} route={ROUTES.AUTHENTICATION.LOGOUT} />,
            title: "Session Options",
            closable: true,
            callback: (_r) => {
                window.bm_state.value = ROUTES.RECONCILIATION.RECONCILIATION;
            }
        })

    }


    const showExtras = () => {
        window.bm_state.value = ROUTES.RECONCILIATION.EXTRA;
        createModal({
            component: <ReconciliationExtras fetch={fetch} controller={controller} filters={filters} route={ROUTES.RECONCILIATION.EXTRA} />, title: "Reconciliation Menu", closable: true, callback: (_r) => {
                if (_r) {
                    if (_r === "purge") {
                        
                        setIsNew(false);
                        fetch(false);
                    }

                }
                window.bm_state.value = ROUTES.RECONCILIATION.RECONCILIATION;
            }
        })
    }

    const adjust = () => {
        let _id = selected?.reconciliation_id;
        if (!_id) { showError({ error: "No record selected." }); return; }
        showConfirm({
            controller: controller,
            route: ROUTES.RECONCILIATION.ADJUST, title: "Adjust?", description: <>Adjust this O/H to agree with counted quantity?</>, callback: (_ret) => {
                if (_ret) {
                    pubCall("reconciliation.adjust", { reconciliation_id: _id }, (_s, _r) => {
                        if (!_s) {
                            showError({ error: "NOT IMPLEMENTED" });
                            // let _data = [...data].filter(item => item.reconciliation_id !== _id);
                            // setData(_data);
                            // setSelected((_data.length > 0) ? _data[_data.length - 1] : {});
                        } else {
                            showError(_r);
                        }
                        window.bm_state.value = route;
                    })
                } else {
                    window.bm_state.value = route;
                }
            }
        })
    }

    const showImport = () => {
        window.bm_state.value = ROUTES.RECONCILIATION.IMPORT;
        createModal({
            component: <ImportCounts controller={controller} filters={filters} route={ROUTES.RECONCILIATION.IMPORT} />, title: "Import Inventory count file", closable: true, callback: (_r) => {
                if (_r) {
                    setLoading(true);
                    pubCall("reconciliation.getInitial", filters, (_s, _r) => {
                        if (_s) {
                            if (_r.rows_previous.length > 0) {
                                setAlign("start");
                            }
                            setData(_r.rows_previous.concat(_r.rows_next));
                            setSelected((_r.rows_next.length > 0) ? _r.rows_next[0] : {})
                        } else {
                            showError(_r);
                        }
                        setLoading(false);
                    })

                }
                window.bm_state.value = route;
            }
        })
    }



    //[TEMP] SHOW ONLY RECONCILIATION
    const menu = [
        {
            // key : KBD.A, 
            text: "Adj",
            // action : () => adjust() 
        },
        { key: KBD.D, text: "Del", action: () => deleteRow() },
        { key: KBD.E, text: "Edit", action: () => toggleEdit() },
        { text: "@Edit" },
        { key: KBD.F, text: "Filt", action: () => setFilters({ ...filters, "oh_filter": !filters.oh_filter }) },
        { key: KBD.I, text: "Import", action: () => showImport() },
        { text: "Lbl" },
        { key: KBD.N, text: "New", action: () => getNew() },
        { text: "Ord" },
        { text: "Print" },
        { key: KBD.S, text: "Srch", action: () => showSearch() },
        { key: KBD.W, text: "Wksn", action: () => setFilters({ ...filters, "work_station_filter": !filters.work_station_filter }) },
        { key: KBD.X, text: "Xtras", action: () => showExtras() },
        { key: KBD.ARROW_LEFT, action: (e) => { switchView() } },
        { key: KBD.ARROW_RIGHT, action: (e) => { switchView() } },
        { text: "Zrtn" },
        { text: "Hst", key: KBD.H, action: () => switchView() },

    ];


    const getStockData = () => {
        if (isNew) {
            // display stock row above the new
            if (data.length > 1) {

                return data[data.length - 2]?.stock_data || {};
            }
            return {};
        }
        if (selected) {
            if (fullData.stock?.stock_id === selected?.stock_data?.stock_id) {
                return (fullData) ? fullData.stock : selected.stock_data;
            }
            return selected.stock_data

        } else {
            return {}
        }
    }

    // (!isNew) ? selected?.stock_data : (data.length > 1) ? data[data.length - 2]?.stock_data : {}

    const searchISBN = (_barcode) => {
        pubCall("reconciliation.search", { isbn: _barcode, work_station_filter: filters.work_station_filter, limit: 45 }, (_s, _r) => {
            if (_s) {
                if (_r.rows_previous.length > 0) {
                    setAlign("start");
                }
                setData(_r.rows_previous.concat(_r.rows_next));
                setSelected((_r.rows_next.length > 0) ? _r.rows_next[0] : {})
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }

    useEffect(() => {
        const actions = [
            { key: KBD.ESCAPE, action: (e) => { callback() } },
            { key: KBD.ENTER, action: (e) => { callback(false) } },
        ];
        const cleanup = listen(controller, route, actions.concat(menu), false, [], [], [], (e) => searchISBN(e));
        return cleanup;
    }, [selected, edit, data]);




    return (
        <div className="controller">
            <div style={{ height: "calc(100vh - 140px)", minHeight: "511px", gap: "15px" }}>
                <InventoryDetails controller={controller} updateRow={() => { }} switchEdit={() => { }} in_stock={true} edit={false} stock_data={getStockData()} />

                <div className="shim" /><div className="shim" /><div className="shim" />

                <Space grow style={{ "alignItems": "flex-start", "padding": "0px 15px" }} size={15}>
                    <ReconciliationList
                        view={state?.view}
                        controller={controller}
                        edit={edit}
                        isNew={isNew}
                        setIsNew={setIsNew}
                        signal={signal}
                        align={align}
                        setAlign={setAlign}
                        selected={selected}
                        setSelected={setSelected}
                        filters={filters}
                        setFilters={setFilters}
                        loading={loading}
                        setLoading={setLoading}
                        data={data}
                        setData={setData}
                        route={route}
                        updateRow={updateRow}
                        tabs={tabs}
                        setTabs={setTabs}
                        index={index}
                        setIndex={setIndex}
                    />

                    <div style={{ "height": "calc(100vh - 440px)", minHeight: "214px", "display": "flex", "flexDirection": "column" }}>
                        <div style={{ "flex": "1", "width": "610px" }}>

                            <InventoryHistory
                                controller={controller}
                                filters={historyFilters}
                                setFilters={setHistoryFilters}
                                fullData={fullData}
                                history={fullData?.history}
                                in_stock={in_stock}
                                route={ROUTES.INVENTORY.HISTORY}
                                view={state.view}
                                switchView={switchView}
                                selected={selected}
                                data={[]}

                            />
                        </div>

                    </div>
                </Space>






            </div>

            <div className="shim" />
            <Divider />

            <div style={{ 'height': "30px" }}>
                <Space style={{ "padding": "0px 15px" }}>
                    {((!isNew && !edit && state?.view !== "history") && <Nav nav={menu} />)}
                    {(edit && <Status><InfoIcon />Changing counted qty and counted ISBN</Status>)}
                    {(isNew && <Status><InfoIcon />Enter ISBN or use + - or a Qty, or D to delete the last entry </Status>)}
                </Space>
            </div>

        </div>

    )
}